import React from 'react';
import { Link } from 'react-router';

import PageBackground from 'components/Background';
import ReferralsComponent from 'components/Referrals';
import { TELEGRAM_GROUP_LINK } from 'const';
import 'pages/styles.scss';

function Referrals(props) {
  return (
    <div className='Referrals'>
      <div className='ReferralsDisclaimer'>
        <p>Cross-chain referrals are working in experimental mode</p>
        <p>Please report all errors & inconsistencies in our
          <a href={TELEGRAM_GROUP_LINK}> Telegram community</a>
        </p>
        <p>More details can be found in our <Link to='/faq'>FAQ</Link></p>
      </div>
      <PageBackground />
      <ReferralsComponent />
    </div>
  );
};

export default Referrals;
